/**
 * Chrome meldet oft den harmlosen Fehler
 * "ResizeObserver loop completed with undelivered notifications."
 * wenn Layout und ResizeObserver im gleichen Frame laufen (Flex, Canvas, Charts …).
 *
 * 1) rAF: Callback einen Frame verschieben (hilft in vielen Fällen).
 * 2) window.error in Capture-Phase: verhindert, dass CRA/react-error-overlay das Overlay zeigt.
 * 3) console.error-Filter: manche Toolchains loggen denselben Text und triggern das Overlay.
 */
function isBenignResizeObserverNoise(msg) {
  if (msg == null) return false;
  const s = typeof msg === 'string' ? msg : String(msg);
  const lower = s.toLowerCase();
  return (
    lower.includes('resizeobserver loop completed with undelivered notifications') ||
    lower.includes('resizeobserver loop limit exceeded')
  );
}

// ── ResizeObserver: Callback über nächsten Frame ───────────────────────────
const RO = window.ResizeObserver;
if (typeof RO === 'function') {
  window.ResizeObserver = class ResizeObserver extends RO {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

// ── CRA Dev-Overlay: harmlosen Browser-Noise nicht als „Uncaught runtime error“ zeigen ──
function swallowIfBenignResizeObserver(event) {
  const msg =
    event?.message ||
    event?.error?.message ||
    (typeof event?.reason === 'string' ? event.reason : event?.reason?.message) ||
    '';
  if (isBenignResizeObserverNoise(msg)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}

window.addEventListener('error', swallowIfBenignResizeObserver, true);

window.addEventListener('unhandledrejection', swallowIfBenignResizeObserver, true);

const _consoleError = console.error.bind(console);
console.error = (...args) => {
  if (args.length && isBenignResizeObserverNoise(args[0])) {
    return;
  }
  _consoleError(...args);
};
